import axios from 'axios';
import {getRuntimeConfig} from '../config/runtime-config';

export const publicApi = axios.create({
  baseURL: getRuntimeConfig().apiUrl,
  withCredentials: false,
});

export const updatePublicApiBaseUrl = () => {
  publicApi.defaults.baseURL = getRuntimeConfig().apiUrl;
};
